export interface TooltipOwner {
  close: () => void
}

const tooltipOwners = new WeakMap<HTMLElement, TooltipOwner>();

export function registerTooltipOwner(element: HTMLElement, owner: TooltipOwner): void {
  tooltipOwners.set(element, owner);
}

export function unregisterTooltipOwner(element: HTMLElement): void {
  tooltipOwners.delete(element);
}

export function getTooltipOwner(element: HTMLElement): TooltipOwner | undefined {
  return tooltipOwners.get(element);
}